import { gql } from '@apollo/client';

export const ROTATIONSPLAN_VORLAGEN = gql(`
  query mitarbeiter_rotationsplanVorlagen {
    mitarbeiter_rotationsplanVorlagen {
      id
      standortId
      titel
      land
      beruf {
        id
        name
        abkuerzung
        istAusbildung
        markierung
      }
      abschnitte {
        id
        name
        position
        stationen {
          id
          typ
          position
          dauer
          dauerEinheit
          lernziele
          arbeitsbereich {
            id
            name
            markierung
          }
        }
      }
    }
  }
`);
